import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";

import { WorkspaceRoutes } from "./CommonRoutesList";

import LoadingScreen from "@/components/state-pages/LoadingScreen";
import { ROUTES } from "@/constants/routes_sidebar/routes-constant";
import ProtectedRoute from "@/routers/ProtectedRoutes";

// Lazy load components
const Login = lazy(() => import("@/pages/auth/login/index"));
const Page404 = lazy(() => import("@/pages/Page404"));
const WorkspaceGrid = lazy(() => import("@/pages/workspaces/GridView"));
const WorkspaceTable = lazy(() => import("@/pages/workspaces/TableView"));
const Customer = lazy(() => import("@/pages/clients/customer/index"));

// Loading fallback component

const AdminRoutes = (): React.JSX.Element => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path='/login/:token?' element={<Login />} />
        <Route path='*' element={<Page404 />} />
        <Route element={<ProtectedRoute />}>
          <Route path='/' element={<WorkspaceGrid />} />
          <Route path='/table' element={<WorkspaceTable />} />
          <Route path={`${ROUTES.WORKFORCE}/*`} element={<WorkspaceRoutes />} />
          <Route path={`${ROUTES.CUSTOMERS}`} element={<Customer />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AdminRoutes;
